export default __webpack_public_path__ + "static/notebook-2-af578a774d7517dc164be861fb410f2f.jpeg";